import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import groupingMiddleware from "./middleware/auth/groupingValidRoute";

// ✅ Lazy imports
const GroupingList = lazy(() => import("app/pages/Grouping/ListGrouping"));
const CreateGroup = lazy(() => import("app/pages/Grouping/Create"));
const RejectGroup = lazy(() => import("app/pages/Grouping/Modal/rejectGroup"));
const IssueForCutting = lazy(() => import("app/pages/Grouping/ListGrouping/IssueForCutting"));

export const groupingRoutes = [
  {
    middleware: [
      {
        element: groupingMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/grouping",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={GroupingList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/grouping/add",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateGroup} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/grouping/reject",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={RejectGroup} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/grouping/issuecutting",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={IssueForCutting} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
];
